module.exports = __webpack_public_path__ + "img/fcc.00093c29.jpeg";